import { sammelnClient } from '@xver/libs/axios';

import {
    CreateRetentionPolicyRequest,
    DeleteRetentionPolicyResponse,
    ListRetentionPoliciesResponse,
    RetentionPolicyResponse,
    UpdateRetentionPolicyRequest,
} from './model';

const ENDPOINTS = {
    LIST: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/retention-policies`,
    CREATE: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/retention-policies`,
    GET: (projectIdOrName: string, id: string) =>
        `/v1/projects/${projectIdOrName}/retention-policies/${id}`,
    UPDATE: (projectIdOrName: string, id: string) =>
        `/v1/projects/${projectIdOrName}/retention-policies/${id}`,
    DELETE: (projectIdOrName: string, id: string) =>
        `/v1/projects/${projectIdOrName}/retention-policies/${id}`,
};

export function listRetentionPolicies(
    projectIdOrName: string
): Promise<ListRetentionPoliciesResponse> {
    return sammelnClient.get(ENDPOINTS.LIST(projectIdOrName));
}

export function getRetentionPolicy(
    projectIdOrName: string,
    id: string
): Promise<RetentionPolicyResponse> {
    return sammelnClient.get(ENDPOINTS.GET(projectIdOrName, id));
}

export function createRetentionPolicy(
    projectIdOrName: string,
    data: CreateRetentionPolicyRequest
): Promise<RetentionPolicyResponse> {
    return sammelnClient.post(ENDPOINTS.CREATE(projectIdOrName), data);
}

export function updateRetentionPolicy(
    projectIdOrName: string,
    id: string,
    data: UpdateRetentionPolicyRequest
): Promise<RetentionPolicyResponse> {
    return sammelnClient.put(ENDPOINTS.UPDATE(projectIdOrName, id), data);
}

export function deleteRetentionPolicy(
    projectIdOrName: string,
    id: string
): Promise<DeleteRetentionPolicyResponse> {
    return sammelnClient.delete(ENDPOINTS.DELETE(projectIdOrName, id));
}
